import { useState, useSyncExternalStore } from "react";
import { depsChanged } from "./useSyncOnChange";

const serverSnapshot = () => undefined;

const createClientSnapshot = <T>(read: () => T) => {
  let snapshot: T | undefined;
  return {
    getSnapshot: () => snapshot,
    subscribe: (onChange: () => void) => {
      snapshot = read();
      onChange();
      return () => undefined;
    },
  };
};

/**
 * 初回、または依存値が変わった commit の後に、ブラウザの初期値を一度だけ読む。
 * SSR / hydration の最初の描画では undefined を返す。通常の再描画では読み直さない。
 *
 * read は URL / Storage などの同期的な読み取りだけに使う。
 * 通信、state / ref の更新、親への通知には使わない。読み取りに使う値は依存値に含める。
 */
export const useClientSnapshot = <T>(read: () => T, dependencies: readonly unknown[]): T | undefined => {
  const [source, setSource] = useState(() => ({ dependencies, store: createClientSnapshot(read) }));
  if (depsChanged(source.dependencies, dependencies)) {
    setSource({ dependencies, store: createClientSnapshot(read) });
  }
  return useSyncExternalStore(source.store.subscribe, source.store.getSnapshot, serverSnapshot);
};
